// extracted by mini-css-extract-plugin
export var centerText = "_de-8";
export var container = "_de-0";
export var doughnutContainer = "_de-7";
export var legend = "_de-a";
export var legendItemColorDisplay = "_de-b";
export var legendItemLabel = "_de-d";
export var legendItemValue = "_de-c";
export var lg = "_de-5";
export var maxWidth = "_de-9";
export var md = "_de-4";
export var responsive = "_de-6";
export var sm = "_de-3";
export var xs = "_de-2";
export var xxs = "_de-1";